/**
 * BRANDS -- ENDPOINTS
 * @description
 * [ENDPOINTS] - This are the list of endpoints for the brands module
 */
// eslint-disable-next-line
export const BRAND = {
  BRANDS_ALL: 'brands/findAll' as 'brands/findAll',
  BRANDS_ID: 'brands/findOne' as 'brands/findOne',
  BRANDS_ADD: 'brands/create' as 'brands/create',
  BRANDS_UPDATE: 'brands/update' as 'brands/update',
  BRANDS_DELETE: 'brands/delete' as 'brands/delete',
}
